import Container, { Service } from "typedi";
import IHttpClientGetParameters from "../contracts/http-client/http-client-get-parameters.interface";
import IHttpClientPatchParameters from "../contracts/http-client/http-client-patch-parameters.interface";
import IHttpClientPostParameters from "../contracts/http-client/http-client-post-parameters.interface";
import HttpClient from "./http-client.service";

@Service()
export default class AuthService {
    public async updatePassword (event_identifier: string, password_token: string, data: any) {
        const httpParams: IHttpClientPatchParameters = {
            url: `/event/${event_identifier}/participant/password/token/${password_token}`,
            requireToken: true,
            payload: data
        }
        const response: any = await Container.get(HttpClient).patch(httpParams, event_identifier)
        return response
    }

    public async emailResetPassword (event_identifier: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/password/token`,
            requireToken: true,
            payload: data
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async emailLoginDetails (event_identifier: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/login-details-email`,
            requireToken: true,
            payload: data
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async login (event_identifier: string, query_string: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/session${query_string}`,
            requireToken: false,
            payload: data
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async redeemAdminHandoff (event_identifier: string, handoff: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/session/admin-handoff`,
            requireToken: false,
            payload: { handoff }
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async registrationsForEmail (event_identifier: string, email: string) {
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}/registrations-for-email?email=${encodeURIComponent(email)}`,
            requireToken: false
        }
        const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
        return response
    }

    public async entryLinkPeek (event_identifier: string, token: string) {
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}/entry-link/${encodeURIComponent(token)}`,
            requireToken: false
        }
        const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
        return response
    }

    public async entryLinkConsume (event_identifier: string, token: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/entry-link/${encodeURIComponent(token)}/consume`,
            requireToken: false
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async refreshToken (event_identifier: string, form: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/me/session/refresh-token`,
            requireToken: true
        }
        if (form) {
            httpParams.payload = { form: form }
        }
        return await Container.get(HttpClient).post(httpParams, event_identifier)
    }

    public async registration(event_identifier: any, query_string: string, data: any, bearerToken?: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/registration${query_string}`,
            requireToken: false,
            payload: data
        }
        if (bearerToken) {
            // Per-request header (not defaults.headers.common). `url` is repeated because HttpClient
            // merges config with a shallow Object.assign that replaces headers.
            httpParams.config = {
                headers: {
                    url: window.location.href,
                    Authorization: `Bearer ${bearerToken}`
                }
            }
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async requestInvite (event_identifier: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/registration-form/invite-request`,
            requireToken: true,
            payload: data
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async getSession (event_identifier: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/session`,
            requireToken: true,
            payload: data
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async getParticipant (event_identifier: string) {
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}/participant/me`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
        return response
    }
}
